import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import "material-design-icons-iconfont/dist/material-design-icons.css";
import Moment from "moment";
import { extendMoment } from "moment-range";
import "./registerServiceWorker";
import {
  copy,
  flattenObject,
  generate_id,
  replacePlaceholders
} from "./utils/services";
import DatabaseHelper from "./utils/helper";
import eventBus from "@/eventBus";
import DatetimePicker from "vuetify-datetime-picker";
import axios from "axios";
import { mapGetters } from "vuex";
import './registerServiceWorker'
Vue.use(DatetimePicker);
const moment = extendMoment(Moment);

Vue.config.productionTip = false;

Vue.prototype.$dbUrl = process.env.VUE_APP_DATABASE_URL;

Vue.prototype.$network = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  timeout: 4000,
  headers: {'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*'}// set default header for all requests
});

Vue.prototype.$db = {};

Vue.mixin({
  computed: {
    ...mapGetters(["profile"]),
    isOnline() {
      return navigator.onLine;
    }
  },
  watch: {
    isOnline(status) {
      console.log(status);
      if (!status) return;
      store.dispatch("scheduleOffine");
    }
  },
  methods: {
    $back() {
      window.history.back();
    },
    moment,
    $processing(value) {
      eventBus.$emit("setProcessing", value);
    },
    $generate_id(...prefixes) {
      return generate_id(...prefixes);
    },
    $copy(obj) {
      return copy(obj);
    },
    /**
     *
     * @param link {String} => A string parameter that can be modified using standard vue route syntax. e.g edit/:_id/
     * @param obj {Object} => The object from which values for the link would be drawn from
     * @param extras {...Object} => Extra objects which values can be fetched from
     */
    $getLink(link, obj, extras = {}) {
      return replacePlaceholders(link, { ...obj, ...extras });
    },
    $handleInput(value) {
      /**
       * Echoes an input event down the DOM parent tree.
       */
      this.$emit("input", value);
    },
    /**
     * Creates a new database instance making it accessible across app.
     * @param name -> the name of the database
     * @param local -> the local database referernce
     * @param remote -> the remote database url
     * @param primary -> the primary database
     */
    $createDatabase(name, local, remote, primary = 0) {
      this.$db[name] = new DatabaseHelper(local, remote, primary);
    },
    $flattenObj(obj, parent, res) {
      return flattenObject(obj, parent, res);
    },
    $register() {
      if (this.profile) {
        console.log('profile', this.profile);
        this.$network.defaults.headers.username = this.profile.name;
        const agendas = `user-${this.profile.userId}-agendas`;
        this.$network.defaults.headers.username = this.profile.name;
        this.$network.defaults.headers.token = this.profile.roles[0];
        this.$createDatabase("agendas", agendas, `${this.$dbUrl}${agendas}`, 0);
        this.$db.agendas.sync();
      }
    }
  }
});

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
